import { NgClass } from '@angular/common';
import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AvatarModule } from '@openng/optimus-ui/avatar';
import { RouterLink, RouterLinkActive } from "@angular/router";
import { ConnectwiseService } from '../shared/services/connectwise.service';
import { OverlayBadgeModule } from '@openng/optimus-ui/overlaybadge';
import { MicrosoftGraphService } from '../shared/services/microsoft-graph.service';
import { ThemeSwitcherComponent } from '../theme/theme-switcher/theme-switcher';

@Component({
  selector: 'app-sidebar',
  imports: [
    NgClass,
    AvatarModule,
    RouterLink,
    RouterLinkActive,
    OverlayBadgeModule,
    ThemeSwitcherComponent,
  ],
  templateUrl: './sidebar.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidebar.css',
})
export class SidebarComponent {
  private readonly authService = inject(MsalService);
  private readonly microsoftGraphService = inject(MicrosoftGraphService);
  private readonly connectwiseService = inject(ConnectwiseService);
  protected readonly openedTimesheets = computed(() => this.connectwiseService.timesheetsResource.value());
  protected readonly userPhotoUrl = this.microsoftGraphService.userPhotoUrl
  protected readonly account = signal(
    this.authService.instance.getActiveAccount(),
  );

}
